var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFstlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6029 10L17.4466 10L13.133 10L13.133 14.8228L17.868 14.8228L16.748 17.7301C18.2503 16.4497 21.2551 14.6558 24.964 14.7506L27.769 14.7506L27.7808 10L26.8784 10L22.6029 10Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4041 18.7252C20.1271 16.354 22.7022 15.9375 25.3383 15.9375H27.7796L27.7796 23.3235L22.9544 23.3242V20.7374C19.6634 20.7717 14.4296 22.9462 13.1318 29.7204C13.1318 24.437 14.8135 20.9811 17.4041 18.7252Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1698 29.5298C13.1565 29.6172 13.1439 29.7052 13.1318 29.7941H17.9205C17.9205 26.3916 18.9976 21.4452 22.939 20.7383C19.6783 20.7788 14.5264 22.9164 13.1698 29.5298Z",
    fill: "#535862"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFstlogo);
export default __webpack_public_path__ + "static/media/fstlogo.36dfa1230ef25eed2155592ae1335819.svg";
export { ForwardRef as ReactComponent };